import { ApiNames, ApiProxy, ApiRequest, HttpMethod } from '@lib/api/apiProxy';

export class PhotosCommandApi {
  private static apiProxy = ApiProxy.getInstance();
  private static apiName = ApiNames.Photos;

  public static async uploadImage(
    uploadUrl: UploadUrl,
    photoFile: File | Blob
  ): Promise<string | void> {
    const formData = this._photoFormData(uploadUrl, photoFile);
    const options = this._photoRequestOptions(formData);
    try {
      const response = await fetch(uploadUrl.url, options);
      return response.text();
    } catch (error) {
      throw new Error('Something went wrong when uploading image');
    }
  }

  public static createUserPhoto(
    userPhoto: UserPhotoDTO
  ): Promise<UserPhotoUploadResponse> {
    return this.apiProxy.execute(
      new ApiRequest(
        this.apiName,
        `/casting/user/${userPhoto.user_id}`,
        HttpMethod.POST,
        userPhoto
      )
    );
  }

  private static _photoFormData(
    uploadUrl: UploadUrl,
    photoFile: File | Blob
  ): FormData {
    const result = new FormData();
    for (const [key, value] of Object.entries(uploadUrl.fields)) {
      result.append(key, value);
    }
    result.append('file', photoFile, uploadUrl.fields.key);
    return result;
  }

  private static _photoRequestOptions(formData: FormData): RequestInit {
    const result: RequestInit = {
      method: HttpMethod.POST,
      body: formData,
      redirect: 'follow',
    };
    return result;
  }

  public static updateProfilePic(
    photoId: number,
    userPhoto: UserPhotoDTO
  ): Promise<UserPhotoUploadResponse> {
    return this.apiProxy.execute(
      new ApiRequest(
        this.apiName,
        `/casting/user/${photoId}`,
        HttpMethod.PUT,
        userPhoto
      )
    );
  }
}
